import { TTreeNode } from './types';

export const findNodeById = (tree: TTreeNode[], id: number | string): TTreeNode | null => {
  for (const node of tree) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNodeById(node.children, id);
      if (found) return found;
    }
  }
  return null;
};

export const deleteNodeById = (tree: TTreeNode[], id: number | string): boolean => {
  const index = tree.findIndex((node) => node.id === id);
  if (index !== -1) {
    tree.splice(index, 1);
    return true;
  }
  for (const node of tree) {
    if (node.children?.length) {
      const childIndex = node.children.findIndex((child) => child.id === id);
      if (childIndex !== -1) {
        node.children = [...node.children.slice(0, childIndex), ...node.children.slice(childIndex + 1)];
        return true;
      }
      if (deleteNodeById(node.children, id)) return true;
    }
  }
  return false;
};

export const addNodeToTree = (tree: TTreeNode[], newNode: TTreeNode): boolean => {
  if (newNode.parent === -1) {
    tree.push(newNode);
    return true;
  }
  for (const node of tree) {
    if (node.id === newNode.parent) {
      node.children = node.children ?? [];
      node.children.push(newNode);
      return true;
    }
    if (node.children && addNodeToTree(node.children, newNode)) {
      return true;
    }
  }
  return false;
};

export const updateNodeInTree = (tree: TTreeNode[], updatedNode: TTreeNode): boolean => {
  const index = tree.findIndex((node) => node.id === updatedNode.id);
  if (index !== -1) {
    const oldChildren = tree[index].children || [];
    tree[index] = { ...updatedNode, children: oldChildren };
    return true;
  }
  for (const node of tree) {
    if (node.children && updateNodeInTree(node.children, updatedNode)) {
      return true;
    }
  }
  return false;
};

export const collectSubtreeIds = (tree: TTreeNode[], rootId: number | string): number[] => {
  const node = findNodeById(tree, rootId);
  if (!node) return [];

  const ids: number[] = [];
  const visit = (n: TTreeNode) => {
    ids.push(n.id);
    n.children?.forEach(visit);
  };
  visit(node);
  return ids;
};
